import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, doc, updateDoc, getDocs } from "firebase/firestore";
import { useAuth } from "../context/AuthContext";
import styled from "styled-components";

const Streaks = () => {
  const { currentUser } = useAuth();
  const [habits, setHabits] = useState([]);

  useEffect(() => {
    if (!currentUser) return;

    const fetchHabits = async () => {
      const habitsRef = collection(db, "users", currentUser.uid, "habits");
      const snapshot = await getDocs(habitsRef);
      const allHabits = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const updatedHabits = allHabits.map((habit) => {
        let streak = 0;
        const completedDates = habit.completedDates || {};
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);

        const todayKey = today.toISOString().split("T")[0]; // Format: YYYY-MM-DD
        const yesterdayKey = yesterday.toISOString().split("T")[0];

        if (completedDates[yesterdayKey]) {
          streak = habit.streak || 0; // Maintain previous streak if yesterday was completed
          if (completedDates[todayKey]) {
            streak++; // Increment streak if today is completed
          }
        } else {
          streak = completedDates[todayKey] ? 1 : 0; // Reset streak if yesterday wasn't completed
        }

        // Update Firestore if the streak has changed
        if (streak !== habit.streak) {
          const habitDoc = doc(
            db,
            "users",
            currentUser.uid,
            "habits",
            habit.id
          );
          updateDoc(habitDoc, { streak });
        }

        return { ...habit, streak };
      });

      setHabits(updatedHabits);
    };

    fetchHabits();
  }, [currentUser]);

  return (
    <Container>
      <h2>Global Habit Streaks</h2>
      <ul>
        {habits.map((habit) => (
          <span key={habit.id}>
            <h3>{habit.name}</h3>
            <h1>{habit.streak} days</h1>
          </span>
        ))}
      </ul>
    </Container>
  );
};

const Container = styled.div`
  padding: 40px 30px;
  background-color: #171c29;
  border-radius: 20px;
  font-family: "Comfortaa";
  width: 100%;
  h2 {
    font-weight: 300;
    text-align: center;
    margin-bottom: 20px;
    color: white;
  }
  ul {
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 1em;
    margin-top: 2em;
    span {
      display: flex;
      background: #20273a;
      justify-content: space-between;
      align-items: center;
      padding: 20px 20px;
      border-radius: 20px;
      h1 {
        font-size: 17px;
      }
    }
  }
  @media (max-width: 1440px) {
    width: 100%;
  }
`;

export default Streaks;
